/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const FETCH_TALON_ONE_REWARDS = 'mbp-member/FETCH_TALON_ONE_REWARDS';
export const FETCH_TALON_ONE_REWARDS_SUCCESS = 'mbp-member/FETCH_TALON_ONE_REWARDS_SUCCESS';
export const FETCH_TALON_ONE_REWARDS_FAILURE = 'mbp-member/FETCH_TALON_ONE_REWARDS_FAILURE';
export const CLEAR_TALON_ONE_REWARDS = 'mbp-member/CLEAR_TALON_ONE_REWARDS';
